import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { Form } from 'react-bootstrap';
import moment from 'moment';
import SelectInput from '../inputs/select';
import { ScheduleDatePickerInput } from '../inputs/date-picker';

const TimesheetHeader = ({
    projectId,
    onProjectChange,
    weekStart,
    onWeekStartChange,
    approved,
    onApprovedChange,
    hasProjectAccess,
    writePermission,
    user,
    onSaveTimesheet
}) => {
    return (
        <div className="timesheet-header">
            <div className="controls-row">
                <div className="filters">
                    <div className="filter-item">
                        <Tooltip
                            title={!hasProjectAccess ? "You don't have access to any projects" : ""}
                            placement="top"
                        >
                            <span>
                                <SelectInput
                                    {...projectId}
                                    onChange={(e) => onProjectChange(e.target.value)}
                                />
                            </span>
                        </Tooltip>
                    </div>
                    <div className="filter-item">
                        <ScheduleDatePickerInput
                            label="Week Starting"
                            value={moment(weekStart).toISOString()}
                            onAccept={(date) => {
                                // Use the exact date selected by user (no snap to Monday)
                                onWeekStartChange(moment(date).toDate());
                            }}
                            disabled={!hasProjectAccess}
                            clearable={false}
                            className={`${hasProjectAccess ? "" : "disabled"} schedule-date-picker-input`}
                        />
                    </div>
                    <Form.Check
                        type="checkbox"
                        id="approved-checkbox"
                        label="Approved"
                        className="approved-checkbox mt-2"
                        checked={approved}
                        onChange={(e) => onApprovedChange(e.target.checked)}
                        disabled={user?.permissions?.timesheetApprover !== 2 || !hasProjectAccess}
                    />
                </div>
                <div className="actions">
                    {(writePermission || user?.permissions?.timesheetApprover === 2) && (
                        <Tooltip
                            title={!hasProjectAccess ? "You don't have access to any projects" : ""}
                            placement="top"
                        >
                            <span>
                                <Button
                                    variant="contained"
                                    className={`${hasProjectAccess ? "" : "disabled"} text-white btn-bg-brand-1 save-timesheet-button`}
                                    onClick={onSaveTimesheet}
                                    disabled={!hasProjectAccess}
                                >
                                    Save Timesheet
                                </Button>
                            </span>
                        </Tooltip>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TimesheetHeader;
